<template>
  <div class="file-input clearfix">
    <div
      class="drop-zone text-bold text-center"
      @dragover.prevent
      @drop="onDrop"
    >Arrastra un archivo.</div>
    <div class="files clearfix">
      <div class="file" v-for="(file, index) in files" v-bind:key="index">
        <p>{{file.name}}</p>
        <i class="fa fa-times-circle" v-on:click="removeFile(index)"></i>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  props: {
    files: Array
  },
  methods: {
    removeFile(index) {
        this.files.splice(index, 1)
    },
    onDrop(event) {
      event.preventDefault();
      event.stopPropagation();
      if (event.dataTransfer.files) {
        for (let file of event.dataTransfer.files) {
          this.files.push(file);
        }
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.drop-zone {
  padding: 1.4em;
  border: 1px solid rgba(0, 0, 0, 0.2);
}
::-webkit-scrollbar {
  height: 5px;
}
::-webkit-scrollbar-thumb {
  background: #888;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #555;
}
.files {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  overflow-x: scroll;

  overflow-y: visible;
  /* Handle */

  .file {
    margin-left: 1em;
    margin-top: 10px;
    width: 250px;
    height: 5em;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    border: 1px solid black;
    padding: 0.5em;
    padding-top: 1em;
    padding-bottom: 1em;
    .fa {
      color: red;
      cursor: pointer;
      position: relative;
      bottom: 10px;
      left: 20px;
    }
  }
}
</style>